<template>
  <!--
    Components are called here in order to show a piece of the application, either to use vue-router to change the showing piece of application depending on the router, or use these components within Laravel as tags injected to blade files.
   -->
    <router-view></router-view>
</template>
<script>
  export default {
    data (){
      return {

      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/App.vue